import * as SegmentI from "./Segment";
import * as SegmentTarget from "./SegmentTarget";

const SequencePattern: {
  [name: string]: { [flavor: string]: { [func: string]: any } };
} = {
  Segment: {
    default: {
      START: SegmentI.Start,
      Action: SegmentI.Action,
    },
  },
  SegmentTarget: {
    default: {
      START: SegmentTarget.Start,
      Action: SegmentTarget.Action,
    },
  }
};

export default SequencePattern;
